import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";

export const TimeSquareNoteContent: NoteContent[] = [
  {
    title: "Message to Janice",
    date: "18 Aug 2024",
    content: [
      {
        entry: `"Janice, I just wanted to say before we see each other later - I promise I had absolutely nothing to do with the attack on Karibbean Krush. Of course I would never want to bring harm to you after everything you have done for me and because you are MY SISTER. I don’t know what all this NYPD stuff is but they haven’t been in contact with me so I don’t know if it was some sort of scam or something but I promise promise promise I have absolutely nothing to with a flatbush gang. Can you imagine if I did? Me??? With a gang?

It’s a long story but I’ve been receiving all these designer clothes off a guy I met on an escort site. I know it’s a shameful site but I joined to try and raise some money to pay for the Karibbean Krush damages! I should have told you earlier but tbh I was embarrassed about it and I wanted to just hand you the money no questions asked. You did so much for me and I wanted to pay back the favor."`,
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "@fl0mahoney87",
    date: "18 Aug 2024",
    content: [
      {
        entry: "handmade wool clothes",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Don Pepe's",
    date: "15 Aug 2024",
    content: [
      {
        entry: "Argentine Steak House",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Untitled",
    date: "6 Aug 2024",
    content: [
      {
        entry: "Tacos on W 39th St",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "remember to message uncle frank happy birthday",
    date: "1 Aug 2024",
    content: [
      {
        entry: "remember to message uncle frank happy birthday",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Roy Harris",
    date: "20 July 2024",
    content: [
      {
        entry: 'Infinity 12" edit',
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Key cutting on Brooklyn Ave",
    date: "17 July 2024",
    content: [
      {
        entry: "Ask for Rodney- friend of dennis",
      },
    ],
    locked: false,
    unclickable: false,
  },
];
